import { Component, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SeoService } from './services/seo.service';

declare var jQuery: any;
declare var initializeOnReady: any;
declare var initializeOnLoad: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements AfterViewInit {
  title = 'Vishwas Fotography';

  constructor(private router: Router, private seo: SeoService) {
    this.seo.update(this.router.url);
  }

  footerData = {
    backExists: "0",
    wallpaper: ""
  }

  ngAfterViewInit(): void {
    this.router.events
    .pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    )
    .subscribe(event => {
      this.seo.update(event.urlAfterRedirects);
      this.reinitializeThings();
    });
  }
  
  reinitializeThings() {
    const run = () => {
      try {
        initializeOnLoad();
        initializeOnReady();
      } catch {
        // Legacy theme enhancement is optional; Angular content remains usable.
      }
    };
    const idle = (window as any).requestIdleCallback;
    if (idle) idle(run, { timeout: 1200 }); else setTimeout(run, 350);

  }
}
